<script setup lang="ts">
import { KsButton } from "@aschehoug/kloss";

const currentArticle = inject(keys.currentArticle);

const url = useRequestURL();

const href = computed(() => url.href.replace("http://", "https://"));

const shareData = computed(() => ({
  title: currentArticle?.title,
  url: href.value,
}));

const canShare = computed(
  () =>
    import.meta.client &&
      navigator &&
      !!navigator.share &&
      !!navigator.canShare &&
      navigator.canShare(shareData.value),
);

async function share() {
  if (canShare.value) {
    try {
      await navigator.share(shareData.value);
    } catch {
      // Do nothing
    }
  }
}
</script>

<template>
  <div v-if="currentArticle" class="flex items-center justify-end gap-2">
    <span class="mr-2 font-normal uppercase text-green-50">Del artikkelen:</span>
    <UiSocialLink
      provider="facebook"
      :href="`https://www.facebook.com/sharer/sharer.php?u=${href}`"
      label="Del på Facebook"
      class="bg-green-50 text-beige-10"
      :scale="1.1"
    />
    <UiSocialLink
      provider="linkedin"
      :href="`https://www.linkedin.com/cws/share?url=${href}`"
      label="Del på LinkedIn"
      class="bg-green-50 text-beige-10"
      :scale="1.1"
    />
    <ClientOnly>
      <KsButton
        v-if="canShare"
        class="size-8 bg-green-50 hover:bg-green-40"
        shape="round"
        @click="share"
      >
        <svg
          xmlns="http://www.w3.org/2000/svg"
          viewBox="0 0 35 34"
          fill="none"
        >
          <path
            class="fill-beige-10"
            d="M20.0886 10.3955C19.7183 10.5597 19.4768 10.9299 19.4768 11.3356V13.3961H15.8708C12.7412 13.3961 10.2041 15.9331 10.2041 19.0625C10.2041 22.7103 12.8282 24.3394 13.4302 24.6678C13.5107 24.7128 13.6009 24.7289 13.691 24.7289C14.042 24.7289 14.3253 24.4424 14.3253 24.0947C14.3253 23.8532 14.1869 23.6311 14.0098 23.4669C13.7071 23.1803 13.295 22.6169 13.295 21.6382C13.295 19.9318 14.6795 18.5474 16.3859 18.5474H19.4768V20.6079C19.4768 21.0136 19.7151 21.3838 20.0886 21.548C20.4621 21.7122 20.8935 21.6446 21.1961 21.3742L26.3477 16.738C26.5634 16.5416 26.6889 16.2647 26.6889 15.9717C26.6889 15.6788 26.5666 15.4019 26.3477 15.2055L21.1961 10.5693C20.8935 10.2957 20.4588 10.2281 20.0886 10.3955Z"
          />
        </svg>
      </KsButton>
    </ClientOnly>
  </div>
</template>
